import React, {useRef} from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import {ProductModel} from "../../interfaces";
import SbsEyeIcon from "../../icons/sbs-eye";
import CheckIcon from "../../../../ui/svg/common/check-v";

interface IPluginLgProps {
    product : ProductModel;
    index: number;
}

export const PluginLg = (props : IPluginLgProps) => {

    const ShowPluginImageSortIncludesID = useAppSelector((store) => store.ShowPluginImageSortIncludesID);
    const dispatch = useAppDispatch();
    const eyeIconRef = useRef(null);

    /**
     * ShowPluginImageSortIncludesID is plugin identifier (by SortIncludesID) in order to show plugin view ( after clicking the eye icon)
     * When ShowPluginImageSortIncludesID > 0 --> show the plugin view popup for the specific plugin
     * When ShowPluginImageSortIncludesID <= 0 --> hide plugin view
     *
     * PluginViewPosition is the position (CSS) for positioning the plugin view after eye icon click (speech bubble popup)
     *
     * */
    const SetShowPluginImageSortIncludesID = (event:any) => {
        event.stopPropagation();
        if(eyeIconRef.current !== null){
            // @ts-ignore
            const { left,top } = eyeIconRef.current.getBoundingClientRect();
            dispatch(
                rootActions.main({
                    ShowPluginImageSortIncludesID : props.product.sortIncludes,
                    PluginViewPosition: {top:top,left:left}
                })
            )
        }

        return false;
    }
    return (
        <li key={props.index} className="w-full flex items-center py-2" style={{borderTop:"1px solid #384352"}}>
            <button type={"button"} className="flex items-center justify-center relative z-50 cursor-pointer" style={{width:"37px"}}
                    onClick={SetShowPluginImageSortIncludesID}
                    ref={eyeIconRef}
                    aria-label={`Info popup button for ${props.product.documentName}`}
            >
                <SbsEyeIcon
                    width="18px"
                    color={ ShowPluginImageSortIncludesID === props.product.sortIncludes ? "white" : undefined}
                    title="View Plugin Image"
                />

            </button>
            <div className="flex-1" >{props.product.documentName}{props.product.skuInStoreFrom && props.product.skuInStoreFrom !== '' &&<span className="text-yellow-400"> - NEW</span>}</div>
            <div className="flex items-center justify-center" style={{width:"335px",marginRight:"20px"}}>{props.product.isLow ? <CheckIcon width={"15px"} color={"white"} /> : <></> }</div>
            <div className="flex items-center justify-center"  style={{width:"335px"}}>{props.product.isHigh ? <CheckIcon width={"15px"} color={"white"} /> : <></> }</div>

        </li>
    )
};